import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useAsset, AssetContainer } from '~/techstyle-shared/react-assets';
import { mobile } from '~/techstyle-shared/react-components';

const HeroImage = styled(AssetContainer)`
  && {
    position: absolute;
  }
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  img {
    object-fit: cover;
    min-height: 325px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  isolation: isolate;
  display: flex;
  overflow: hidden;
  width: 100%;

  /* Provide a background to read the white text on before the asset loads in */
  background: ${({ theme }) => theme.colors.palette.black};

  ${mobile`
    min-height: 325px;
  `}

  --image-asset-aspect-ratio: ${(p) =>
    p.$assetWidth !== 0 ? `calc(${p.$assetHeight} / ${p.$assetWidth})` : '0'};

  &::before {
    content: '';
    padding-bottom: calc(100% * var(--image-asset-aspect-ratio));
  }
`;

const HeroTextOverlay = styled.div`
  color: ${({ theme }) => theme.colors.textLight};
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  justify-self: stretch;
  text-align: left;
  align-items: flex-start;
  justify-content: flex-end;
  padding: ${({ theme: { sizes } }) => `${sizes.md}px ${sizes.lg}px`};
  ${mobile`
    max-width: 100%;
    padding: ${({ theme: { sizes } }) => `${sizes.xs}px`};
  `}
`;

const HeroHeader = styled.div`
  font-size: 49px;
  font-weight: 800;
  line-height: 1;
  text-align: left;
`;

const HeroSubheader = styled.div`
  font-size: 26px;
  font-weight: bold;
  line-height: 1;
  text-align: left;
`;

export default function HeroBanner({
  assetName,
  heroHeaderComponent,
  heroSubheaderComponent,
}) {
  const assetContainer = useAsset(assetName);
  const { height: assetHeight, width: assetWidth } = assetContainer?.data || {};

  return (
    <Wrapper $assetHeight={assetHeight} $assetWidth={assetWidth}>
      <HeroImage name={assetName} />
      <HeroTextOverlay>
        <HeroHeader>{heroHeaderComponent}</HeroHeader>
        <HeroSubheader>{heroSubheaderComponent}</HeroSubheader>
      </HeroTextOverlay>
    </Wrapper>
  );
}

HeroBanner.propTypes = {
  assetName: PropTypes.string.isRequired,
  heroHeaderComponent: PropTypes.elementType,
  heroSubheaderComponent: PropTypes.elementType,
};
